@if (userAuthenticated) {
  <div class="spinner-overlay">
    <app-spinner></app-spinner>
  </div>
}
<router-outlet />
<p-toast key="toast-main" position="top-center" [baseZIndex]="5000">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="flex flex-col gap-4 p-2">
      <div class="flex items-center justify-between">
        <span class="font-bold">{{ message.summary | capitalize }}</span>
        <span class="hover:font-bold text-current leading-none text-sm hover:cursor-pointer" (click)="closeFn($event)">
          <i class="pi pi-times"></i>
        </span>
      </div>
      <span>{{ message.detail }}</span>
      @if (message.data?.copyable && message.data?.errorId) {
        <a class="underline link w-fit" href="#" (click)="copyDetail(message.detail, $event)">Copy error</a>
      }
      @if (message.data?.action) {
        <a class="underline link w-fit" href="#" (click)="runToastAction(message.data.action, closeFn, $event)">{{ message.data.action.label }}</a>
      }
      @if (isActiveLoading() && message.data?.isError500) {
        <span>If the page stays unresponsive, click <a class="link" href="#" (click)="reloadPage($event)">Reload page</a> </span>
      }
    </div>
  </ng-template>
</p-toast>
